import { IGatsbyImageData } from 'gatsby-plugin-image'
import { addDomainOnUrl } from '../../Utils/functionnals'
import { FirmTeaserProps } from '../firms'
import { formatNbOffices } from '../firms/format'
import {
  OfferTeaserProps,
  formatContractType,
  formatStartDate,
} from '../offers'
import { SubscriptionType } from '../../types/firm/Subscription'

export type FirmInfosResult = {
  id: number
  name: string
  slug: string
  city: string
  postalCode?: string
  totalEmployees: string
  header?: {
    url?: string
    formats?: {
      small?: {
        url?: string
      }
    }
  } | null
  logo: {
    url?: string
  } | null
  nbTotalOffers: number
  nbOffices: number
  subscriptionType?: SubscriptionType
  likeCount?: number
}

export const FirmTeaserMapper = (firm: FirmInfosResult): FirmTeaserProps => {
  const city = firm?.city ?? ''
  const cityCut = city.length > 18 ? `${city.slice(0, 17)}...` : city
  const nbOfficesToDisplay = formatNbOffices(firm.nbOffices)
  const firmLogo = addDomainOnUrl(firm.logo?.url) ?? null
  const firmHeader = addDomainOnUrl(firm.header?.formats?.small?.url) ?? null

  return {
    name: firm.name,
    city: `${cityCut} ${firm.postalCode ? `(${firm.postalCode.slice(0, 2)})` : ''
      }`,
    header: firmHeader,
    logo: firmLogo,
    totalEmployees: firm.totalEmployees,
    url: `/cabinets/${firm.slug}`,
    nbTotalOffers: firm.nbTotalOffers,
    nbOffices: nbOfficesToDisplay,
    subscriptionType: firm.subscriptionType,
    likeCount: firm.likeCount,
  }
}

export type OfferInfosResult = {
  title: string | null
  payRange?: {
    min: number | null
    max: number | null
  } | null
  contractType?: string | null
  slug: string | null
  startDate?: string | null
  office: {
    city: string | null
    postalCode: string | null
    firm: {
      slug: string | null
      name: string | null
      logo: {
        url: string | null
        localFile: {
          childImageSharp: {
            gatsbyImageData: IGatsbyImageData | null
          } | null
          extension: string | null
          url: string | null
        } | null
      } | null
      header?: {
        localFile: {
          childImageSharp: {
            gatsbyImageData: IGatsbyImageData | null
          } | null
        } | null
      } | null
    } | null
  } | null
}

export const OfferTeaserMapper = (
  offer: OfferInfosResult,
): OfferTeaserProps => {
  const min = (offer.payRange?.min as number) ?? null
  const max = (offer.payRange?.max as number) ?? null
  const url = `/cabinets/${offer.office?.firm?.slug}/offres/${offer.slug}`
  const city = offer.office?.city ? offer.office.city : ''
  const cityCut = city.length > 18 ? `${city.slice(0, 18)}...` : city
  const logo = offer.office?.firm?.logo?.localFile?.url
  const headerImage = offer.office?.firm?.header
    ? offer.office.firm.header.localFile?.childImageSharp?.gatsbyImageData
    : null

  return {
    title: offer.title ?? '',
    companyName: offer.office?.firm?.name ?? '',
    contractType: formatContractType(offer.contractType ?? ''),
    logo,
    url,
    city: `${cityCut} ${offer.office?.postalCode ? `(${offer.office.postalCode.slice(0, 2)})` : ''
      }`,
    headerImage,
    salary: {
      min,
      max,
    },
    startDate: formatStartDate(offer.startDate ?? null),
  }
}
